<template>
  <v-container>
    <v-row align="center" justify="start" dense>
      <v-col v-if="contItems.length == 0">
        <v-alert
          dense
          outlined
          type="error"
          width="70%"
        >
          Контакты не заданы!
        </v-alert>
      </v-col>
      <v-col
        v-else
        v-for="(contItem) in contItems"
        :key="contItem.CONT_ID"
        class="shrink"
      >
        <v-chip
          outlined
          label
          close
          small
          color="blue-grey darken-4"
          class="black--text"
          :close-icon="mode=='edit' ? 'mdi-account-edit' : ''"
          @click:close="editContact(contItem)"
          @click="onContactClick(contItem)"
        >
          <v-avatar left>
            <v-icon
              small
              v-text="contProps(contItem).icon"
              :color="contProps(contItem).iconColor"
            ></v-icon>
          </v-avatar>
          {{ contItem.CONT_VALUE }}
        </v-chip>
      </v-col>
      <v-fab-transition>
        <v-btn
          color="pink"
          x-small
          dark
          bottom
          right
          fab
          v-if="mode=='edit'"
          @click="addContact"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-row>
    <addContactDialog
      v-model="showAddContactDialog"
      :user="user"
      :mode="addContactMode"
      @onUserContactAdded="doAddContact"
      @onUserContactUpdated="doEditContact"
      @onUserContactDeleted="doDeleteContact"
      ref="contactEditor"
    />
  </v-container>
</template>

<script>
import addContactDialog from '@/components/modules/org/structure/staff/dialogs/addContactDialog.vue'
// import editTxtField from '@/components/modules/org/structure/staff/fields/editTxtField.vue'
// import editPhoneField from '@/components/modules/org/structure/staff/fields/editPhoneField.vue'
// import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'userContactsLine',
  props: ['user', 'mode'],
  components: {
    // editPhoneField,
    // editTxtField
    addContactDialog
  },
  data: () => ({
    showAddContactDialog: false,
    addContactMode: 'create'
  }),
  computed: {
    contItems: {
      get: function () {
        if (this.user && this.user.CONTACTS) {
          return this.user.CONTACTS
        }
        return []
      }
    },
    showAddContactButton: {
      get: function () {
        // return this.contact.CONT_TYPE !== -1 && this.contact.CONT_VALUE
        return this.mode === 'edit'
      }
    }
  },
  methods: {
    clearForm () {
    },
    contProps (data) {
      const result = {
        iconColor: 'black',
        icon: 'mdi-pan'
      }
      switch (data.CONT_TYPE) {
        case '0':
          result.icon = 'mdi-email'
          break
        case '1':
          result.icon = 'mdi-certificate'
          break
        case '2':
          result.icon = 'mdi-phone-classic'
          break
        case '3':
          result.icon = 'mdi-cellphone'
          break
      }
      data.CONT_IS_GEN === '0' ? result.iconColor = 'blue' : result.iconColor = 'indigo'
      return result
    },
    onContactClick (item) {
      this.$emit('onContactSelected', item)
    },
    editContact (item) {
      console.log('Called edit contact', item)
      this.addContactMode = 'edit'
      this.$refs.contactEditor.onContactSelected(item)
      this.showAddContactDialog = true
    },
    addContact () {
      console.log('Called add contact')
      this.addContactMode = 'create'
      this.showAddContactDialog = true
    },
    doAddContact (data) {
      this.showAddContactDialog = false
      this.$emit('onUserContactAdded', data)
    },
    doEditContact (data) {
      this.showAddContactDialog = false
      this.$emit('onUserContactUpdated', data)
    },
    doDeleteContact (data) {
      this.$emit('onUserContactDeleted', data)
    }
  }

}
</script>
